export const RESTAURANT_DELIVERY_AREA_CUSTOM = 'custom_poly'

export default {
    custom: RESTAURANT_DELIVERY_AREA_CUSTOM,
}
